$(document).ready(function() {
  $(".complete-the-look__products .ctl-product:lt(9)").css("display", "flex");

  let variantProductLoad = $('select.product-form__option-select').val();
  changeVariantCTL(variantProductLoad);
  reloadLabels();

  let products = $('.complete-the-look__products .ctl-product');
  products.each(function(){
    loadPrice($(this));
  })

  $('.ctl-product__variants select').on('change', function() {
    let product = $(this).closest('.ctl-product');
    loadPrice(product);
  });

  $('select.product-form__option-select').on('change', function() {
    let variant = $(this).val();
    reloadLabels();
    changeVariantCTL(variant);
  });
  
});



function loadPrice(product){
  let variant = product.find('.ctl-product__variants select option:selected');
  let price = variant.attr('data-price');
  let compare = variant.attr('data-compare-price');
  let campaign = variant.attr('data-discount');
  
  product.find('.ctl-product__info-price .price').text(price);

  if(campaign){
    product.find('.ctl-product__info-price .price-campaign-complete').text(campaign);
    if(compare){
      product.find('.ctl-product__info-price .label-campaign-complete').text('SALE SAVING + 20% OFF');
    } else {
      product.find('.ctl-product__info-price .label-campaign-complete').text('20% OFF');
    }
  } else {
    product.find('.ctl-product__info-price .price-campaign-complete').text('');
    product.find('.ctl-product__info-price .price-campaign-complete').hide();
    product.find('.ctl-product__info-price .label-campaign-complete').text('');
    product.find('.ctl-product__info-price .label-campaign-complete').hide();
  }
  
  if(compare){
    product.find('.ctl-product__info-price .compate-at-price').text(compare);
    product.find('.ctl-product__info-price .compate-at-price').show();
  } else {
    product.find('.ctl-product__info-price .compate-at-price').text('');
    product.find('.ctl-product__info-price .compate-at-price').hide();
  }
  
  
}


function reloadLabels(){
  $('.ctl-product__variants select option').each(function() {
    let label = $(this).data('label');
    if (label) {
      $(this).text(label);
    }
  });  
}

function changeVariantCTL(option){
  $('.ctl-product__variants select').each(function() {
    let select = $(this);
    let optionToSelect = select.find(`option[data-label="${option}"]`);
    let targetVariantId = optionToSelect.val();
    if (optionToSelect.length > 0) {
      select.val(targetVariantId).trigger('change');
    }
  });
}









/* AGREGAR AL CARRITO */

function addToCartCollectionCompleteYourSystem() {
  
  const $button = $(event.target);
  const $container = $button.closest('.ctl-product__info-button');
  const $input = $container.find('.number-input-field');
  const quantity = parseInt($input.val());
  var $select = $button.parents('.ctl-product__info').find('.ctl-product__info-variant select');
  var $id = $select.val();

  if (!quantity || quantity < 1) {
    console.error('Cantidad no válida');
    return;
  }

  $button.text('ADDING...');
  $button.prop('disabled', true);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: $id,
      quantity: quantity
    },
    dataType: 'json',
    success: function() {
      $button.text('ADDED!');
      
      setTimeout(() => {
        $button.text('ADD TO CART');
        $button.prop('disabled', false);
      }, 1000);
      
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      $button.text('ERROR');
      setTimeout(() => {
        $button.text('ADD TO CART');
        $button.prop('disabled', false);
      }, 1000);

    }
  });
}